<template lang="pug">
.header-component
  header
    nav.navbar.navbar--ilios.navbar-expand-md.d-flex.flex-row.justify-content-end
      .d-flex.align-items-center
        button.navbar-toggler.d-flex(
          type='button',
          data-ilios-navbar-slide-target='#menuMobile',
          data-ilios-toggle='navbar-slide',
          aria-controls='menuMobile',
          arial-label='Abrir Menu'
        )
          span.navbar-toggler-icon
          .logo-mobile
            img.mx-3(
              v-if='arData.logo !== ""',
              :src='arData.logo',
              alt='logo ar'
            )
            img.mx-3(v-else, src='@/assets/images/Logo.svg', alt='logo ar')
        #menuMobile.navbar-slide
          button#btnClose.navbar-toggler(
            type='button',
            data-ilios-navbar-slide-target='#menuMobile',
            data-ilios-toggle='navbar-slide',
            aria-controls='menuMobile',
            aria-label='Fechar Menu'
          )
            span
              Icon.close-icon(name='xmark')
          .navbar--body
            ul.navbar-nav(:class='menuShow.firstMenu ? "" : "d-none"')
              li.nav-item.item-list
                a.nav-link.active.item-icon(@click='openCertificadeMenu')
                  span Emitir Certificado
                  Icon(name='chevron-right')
              li.nav-item.item-list.item-icon
                a.nav-link(
                  target='_self',
                  @click='navigateTo("/guia-de-instalacao-de-certificado-digital")'
                )
                  span Instalar Certificado
                  Icon(name='chevron-right')
              li.nav-item.item-list.item-icon
                a.nav-link(@click='openRevokeMenu')
                  span Revogar Certificado
                  Icon(name='chevron-right')
              li.item-list.item-icon
                a.nav-link(
                  :href='`https://${subdomain}.acsoluti.com.br/site/verificar-situacao-de-emissao`'
                )
                  span Consultar situação de Certificado
              .navbar--informations.d-flex.flex-column
                .d-flex.flex-row.justify-content-start.p-3
                  Icon(name='user')
                  span.mx-2 {{ arData.foneAR || '(19) 98118-0008' }}
                .d-flex.flex-row.justify-content-start.p-3
                  Icon(name='globe')
                  span.mx-2 {{ getSiteArFormatted }}
                .d-flex.flex-column
                  .d-flex.flex-row.justify-content-start.p-3
                    a.w-100.d-flex.flex-row.justify-content-between(
                      data-bs-toggle='collapse',
                      href='#collapseFaqItems',
                      role='button',
                      aria-expanded='false',
                      aria-controls='collapseExample'
                    )
                      span Ajuda
                      Icon(name='chevron-right')
                  #collapseFaqItems.p-3
                    ul.list-unstyled
                      li
                        FAQSidebarBody
                .d-flex.flex-row.justify-content-start.p-3
                  a(
                    href='https://www.soluti.com.br/fale-conosco',
                    target='_blank',
                    v-if='isPartner'
                  ) Fale conosco

            ul.navbar-nav(:class='menuShow.installMenu ? "" : "d-none"')
              h2(@click='closeMenu')
                Icon.me-2(name='chevron-left')
                span.h-x-small.fw-semi-bold Instalar Certificado
              li.item-icon
                a(@click='navigateTo("/installation-guide-birdid")')
                  img.me-2(
                    style='width: 40px',
                    src='@/assets/images/header-svg/consultar.svg'
                  )
                  span Bird ID
              li.item-icon
                a(@click='navigateTo("/issue/plugin")')
                  img.me-2(
                    style='width: 40px',
                    src='@/assets/images/header-svg/computer.svg'
                  )
                  span Computador
              li.item-icon
                a(@click='navigateTo("/installation-guide-token")')
                  img.me-2(
                    style='width: 40px',
                    src='@/assets/images/header-svg/icons-certificate.svg'
                  )
                  span Token e Smartcard
              li.item-icon
                a(
                  @click='navigateTo("/ssl-certificate/installation-guide-ssl")'
                )
                  img.me-2(
                    style='width: 40px',
                    src='@/assets/images/header-svg/alterar.svg'
                  )
                  span SSL

            ul.navbar-nav(:class='menuShow.certificadeMenu ? "" : "d-none"')
              h2(@click='closeMenu')
                Icon.me-2(name='chevron-left')
                span.h-x-small.fw-semi-bold Emitir Certificado
              li.item-icon
                img(src='@/assets/images/header-svg/videoconferencia.svg')
                a(
                  :href='`https://${subdomain}.acsoluti.com.br/site/emissao-online`'
                ) Por videoconferência
              //- li.item-icon
              //-   img(src="@/assets/images/header-svg/atraves.svg")
              //-   a(href='https://emissao-online-hom.soluti.com.br/' target='_blank') Através de outro Certificado
              li.item-icon(v-if='isPartner')
                img(src='@/assets/images/header-svg/agendar.svg')
                a(href='https://idtech.soluti.com.br/lojas', target='_blank') Agendar visita presencial

              li.item-icon(v-if='isPartner')
                img(src='@/assets/images/header-svg/documentos-pendentes.svg')
                router-link.dropdown-item(to='/login-documents') Enviar documentos pendentes

            ul.navbar-nav(:class='menuShow.revokeMenu ? "" : "d-none"')
              h2(@click='closeMenu')
                Icon.me-2(name='chevron-left')
                span.h-x-small.fw-semi-bold Revogar Certificado
              li.item-icon
                img(src='@/assets/images/header-svg/solicitar.svg')
                a(:href='`https://${subdomain}.acsoluti.com.br/site/revogar`') Solicitar revogação
              li.item-icon
                img(src='@/assets/images/header-svg/alterar.svg')
                a(
                  :href='`https://${subdomain}.acsoluti.com.br/site/senharevogacao`'
                ) Alterar senha de revogação
        #menuDesktop
          ul.navbar-nav.me-auto.d-flex.flex-row.justify-content-end
            li.phone-info.mx-2.d-flex.flex-row.align-items-center.gap-1
              Icon.mx-1.icon(name='phone')
              span.mx-1 {{ arData.foneAR }}
            li.site-info.mx-2.d-flex
              Icon.mx-1.icon(name='globe')
              a.mx-1.color--secondary-900
                span(target='_blank', :href='arData.siteAR') {{ getSiteArFormatted }}
            li
              a.mx-2(
                href='https://www.soluti.com.br/fale-conosco',
                target='_blank',
                v-if='isPartner'
              ) Fale conosco

    nav.navbar.navbar-content-bottom.navbar-expand-md
      .container-fluid
        ul.navbar-nav
          li
            a(@click='navigateToHome', type='button')
              img.mx-3(
                v-if='arData.logo !== ""',
                :src='arData.logo',
                alt='logo ar'
              )
              img.mx-3(v-else, src='@/assets/images/Logo.svg', alt='logo ar')
          li.nav-item.item-list.dropdown.ms-3.d-flex.flex-column.justify-content-center
            a.nav-link.dropdown-toggle(
              role='button',
              data-bs-toggle='dropdown',
              aria-expanded='false'
            )
              span Emitir Certificado
              Icon.ms-2(name='chevron-down')
            ul.dropdown-menu.p-3
              li.dropdown-item.px-0
                a.d-flex.align-items-center.content-container.py-2.px-3(
                  :href='`https://${subdomain}.acsoluti.com.br/site/emissao-online`',
                  target='_blank'
                )
                  img.me-3(
                    src='@/assets/images/header-svg/videoconferencia.svg'
                  )
                  span Por videoconferência
              li.dropdown-item.px-0(v-if='isPartner')
                a.d-flex.align-items-center.content-container.py-2.px-3(
                  href='https://idtech.soluti.com.br/lojas',
                  target='_blank'
                )
                  img.me-3(src='@/assets/images/header-svg/agendar.svg')
                  span Agendar visita presencial
              li.dropdown-item.px-0.border-0(v-if='isPartner')
                router-link.d-flex.align-items-center.content-container.py-2.px-3(
                  to='/login-documents'
                )
                  img.me-3(
                    src='@/assets/images/header-svg/documentos-pendentes.svg'
                  )
                  span Enviar documentos pendentes
          li.nav-item.item-list.dropdown.ms-3.d-flex.flex-column.justify-content-center
            router-link.me-3(
              to='/guia-de-instalacao-de-certificado-digital',
              role='button',
              target='_self'
            )
              span Instalar Certificado
          li.nav-item.item-list.dropdown.d-flex.flex-column.justify-content-center
            a.nav-link.dropdown-toggle(
              role='button',
              data-bs-toggle='dropdown',
              aria-expanded='false',
              target='_blank'
            )
              span Revogar Certificado
              Icon.ms-2(name='chevron-down')
            ul.dropdown-menu.p-3
              li.dropdown-item.px-0
                a.d-flex.align-items-center.content-container.py-2.px-3(
                  :href='`https://${subdomain}.acsoluti.com.br/site/revogar`',
                  target='_blank'
                )
                  img.me-3(
                    style='width: 33px',
                    src='@/assets/images/header-svg/solicitar.svg'
                  )
                  span Solicitar revogação
              li.dropdown-item.px-0.border-0
                a.d-flex.align-items-center.content-container.py-2.px-3(
                  :href='`https://${subdomain}.acsoluti.com.br/site/senharevogacao`',
                  target='_blank'
                )
                  img.me-3(
                    style='width: 33px',
                    src='@/assets/images/header-svg/alterar.svg'
                  )
                  span Alterar senha de revogação
          li.item-list.d-flex.flex-column.justify-content-center
            a.nav-link(
              :href='`https://${subdomain}.acsoluti.com.br/site/verificar-situacao-de-emissao`',
              role='button',
              target='_blank'
            )
              span Consultar situação de Certificado
          li.item-list.d-flex.flex-column.justify-content-center
            router-link.nav-link(to='/faq')
              span Ajuda
</template>
<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import Input from '@/components/Atoms/Input.vue'
  import { mapState } from 'pinia'
  import { useAR } from '@/store/Pinia/useAR.store'
  import mobileAndTabletCheck from '@/utils/browserDeviceCheck'
  import config from '../../../config'
  import FAQSidebarBody from './FAQSidebarBody.vue'

  const DEFAULT_MENU = {
    firstMenu: true,
    certificadeMenu: false,
    revokeMenu: false,
    helpMenu: false,
    installMenu: false,
  }

  export default defineComponent({
    name: 'HeaderComponent',
    components: {
      Icon,
      Input,
      FAQSidebarBody,
    },
    data: () => ({
      menuShow: {
        firstMenu: true,
        certificadeMenu: false,
        revokeMenu: false,
        helpMenu: false,
        installMenu: false,
      },
      form: {
        subdomain: '',
        foneAR: '',
        siteAR: '',
        logo: '',
        nomeAr: '',
      },
      partners: [''],
    }),
    computed: {
      ...mapState(useAR, ['arData', 'getSiteArFormatted']),
      routeHome() {
        return this.subdomain ? this.subdomain : ''
      },
      subdomain() {
        return this.arData.subdomain === 'acsoluti'
          ? 'arsoluti'
          : this.arData.subdomain
      },
      isPartner() {
        return this.partners.includes(this.arData.subdomain || '')
      },
    },
    watch: {
      arData: {
        handler() {
          this.form = {
            ...this.arData,
            subdomain: this.arData.subdomain || '',
          }
        },
        deep: true,
      },
    },
    beforeMount() {
      setTimeout(() => {
        this.form = {
          ...this.arData,
          subdomain: this.arData.subdomain || '',
        }
      }, 1000)
    },
    mounted() {
      this.partners = JSON.parse(JSON.stringify(config.app.partnerNames))
    },
    methods: {
      openCertificadeMenu() {
        this.menuShow.firstMenu = false
        this.menuShow.certificadeMenu = true
        this.menuShow.revokeMenu = false
        this.menuShow.helpMenu = false
      },
      openRevokeMenu() {
        this.menuShow.firstMenu = false
        this.menuShow.certificadeMenu = false
        this.menuShow.revokeMenu = true
        this.menuShow.helpMenu = false
      },
      openHelpMenu() {
        this.menuShow.firstMenu = false
        this.menuShow.certificadeMenu = false
        this.menuShow.revokeMenu = false
        this.menuShow.helpMenu = true
      },
      openInstallMenu() {
        this.menuShow.firstMenu = false
        this.menuShow.certificadeMenu = false
        this.menuShow.revokeMenu = false
        this.menuShow.helpMenu = false
        this.menuShow.installMenu = true
      },
      navigateTo(path: string) {
        this.$router.push({
          path,
        })
        const btn = document.getElementById('btnClose')
        if (btn) {
          btn.click()
        }
      },
      closeMenu() {
        this.menuShow = {
          ...DEFAULT_MENU,
        }
      },
      navigateToHome() {
        if (!mobileAndTabletCheck()) {
          this.$router.push({ name: 'home' })
        }
      },
    },
  })
</script>

<style lang="stylus">
  .header-component
    header
      nav
      .navbar-toggler
        display: none
        .navbar-toggler-icon
          display: none
      .navbar--ilios
        position: relative
        z-index: 1
        background-color: #F0F0F3
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16)
        ul
          background-color: #F0F0F3
          li
            .icon
              padding-top: 0px
        .logo-mobile
          display: none
        #menuDesktop
          ul
            .link-faq
              cursor: pointer
        #menuMobile
          display: none
      .navbar-content-bottom
        --bs-navbar-padding-y: 1rem
        display: block
        background-color: #FFFFFF
        ul
          .dropdown-item:hover
            background-color: #FFFFFF

          .content-container:hover
            border-radius: 16px
            background-color: #E6E7EC
            color: #000000

          li
            // padding: 1rem;
            a[aria-expanded="true"]
              color: #5500AF
              .icon
                transform: rotateX(180deg) !important
            a
              .icon
                position: relative
                bottom: 0.094rem
                margin-top: 5px
            img
              max-height: 55px
      .item-list > a
        color: #2F3242
        width: 100%
        display: flex
        justify-content: space-between
      .item-list > a:hover
        color: #5500AF
  @media screen and (max-width: 767px)
    .header-component
      header
        .navbar-toggler
          display: block
          .navbar-toggler-icon
            display: block
        .navbar--ilios
          position: static
          justify-content: start !important
          ul
            background-color: #FFF !important
          #menuMobile
            display: block
            width: 100% !important
            .close-icon
              margin-left: 1rem
              svg
                height: 1.5rem
            .navbar--body
              .navbar-nav
                h2
                  text-align: left
                  border-bottom: 1px solid var(--color-grayscale-light)
                  padding-bottom: 1.25rem
                  .icon
                    font-size: 1.2rem
              .item-icon
                display: flex
                padding: 1.25rem
                align-items: center
                justify-content: flex-start
                border-bottom: 1px solid var(--color-grayscale-light)
                img
                  width: 40px
                  height: 40px
                  margin-right: 1rem
                span
                  text-align: left
              .item-list > a
                width: 100%
                display: flex
                justify-content: space-between
              .navbar--informations
                div
                  span
                    position: relative
                    top: 0.156rem
          #menuDesktop
            display: none
          .logo-mobile
            display: block
            img
              height: 30px
        .navbar-content-bottom
          display: none
    .navbar--ilios .nav-link
      border-bottom: none;
      --bs-nav-link-padding-y: 0;
      --bs-nav-link-padding-x: 0;

  @keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }
</style>
